<template>
  <div class="footer container">
    <div class="footer-content">
      <div class="flex-between hidden-xs-only footer-row">
        <el-row :gutter="20" class="footer-list">
          <el-col class="footer_widget footer_start" :xs="12" :sm="6" :md="4" :lg="3" :xl="3">
            <h4 class="mb10">技术支持</h4>
            <div class="widget_content">
              <ul>
                <li>
                  <a target="_blank" href="https://help.renderg.com/">用户文档</a>
                  <!-- <router-link to="/404">用户文档</router-link> -->
                </li>
                <li>
                  <a target="_blank" href="https://help.renderg.com/user_agreement.html">用户协议</a>
                </li>
                <li>
                  <router-link to="/render">下载中心</router-link>
                </li>
              </ul>
            </div>
          </el-col>
          <el-col class="footer_widget" :xs="12" :sm="6" :md="4" :lg="3" :xl="3">
            <h4 class="mb10">关于我们</h4>
            <div class="widget_content">
              <ul>
                <li>
                  <router-link to="/about">联系我们</router-link>
                </li>
                <li>
                  <router-link to="/join">加入我们</router-link>
                </li>
                <li>
                  <router-link to="/about">公司介绍</router-link>
                </li>
              </ul>
            </div>
          </el-col>
          <el-col class="footer_widget" :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
            <h4 class="mb10">公司地址</h4>
            <div class="widget_content">
              北京市东城区环球贸易中心E座309  
            </div>
          </el-col>
        </el-row>
        <el-row class="footer-official-box">
          <el-col >
            <div class="official-img-box">
              <img src="../../assets/image/official_pic.jpg" alt="">
            </div>
            <p class="mt10">扫码关注公众号</p>
          </el-col>
        </el-row>
      </div>
      <div class="hidden-sm-and-up footer-row">
        <el-row :gutter="20" class="footer-list">
          <el-col class="footer_widget footer_start" :span="12">
            <h4 class="mb10">技术支持</h4>
            <div class="widget_content">
              <ul>
                <li>
                  <a target="_blank" href="http://rg.sfbp.cn/site/index.html">用户文档</a>
                  <!-- <router-link to="/404">用户文档</router-link> -->
                </li>
                <li>
                  <a target="_blank" href="https://help.renderg.com/user_agreement.html">用户协议</a>
                </li>
                <li>
                  <router-link to="/download">下载中心</router-link>
                </li>
              </ul>
            </div>
          </el-col>
          <el-col class="footer_widget" :span="12">
            <h4 class="mb10">关于我们</h4>
            <div class="widget_content">
              <ul>
                <li>
                  <router-link to="/about">联系我们</router-link>
                </li>
                <li>
                  <router-link to="/join">加入我们</router-link>
                </li>
                <li>
                  <router-link to="/about">公司介绍</router-link>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="flex-align-center footer-official-box">
          <el-col class="footer_widget" :span="12">
            <h4 class="mb10">公司地址</h4>
            <div class="widget_content">
              北京市朝阳区财满街财经中心6号楼16层
            </div>
          </el-col>
          <el-col :span="12">
            <div class="official-img-box">
              <img src="../../assets/image/official_pic.jpg" alt="">
            </div>
            <p class="mt10">扫码关注公众号</p>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="copyright-line">
      <div class="Copyright">
        <!-- <p>Copyright ©2020 renderg.com 备案号： <a href="http://www.beian.miit.gov.cn/">京ICP备10021790号-1</a></p> -->
        <p>Copyright ©{{year}} {{localhost}} 备案号： <a target="_blank" href="https://beian.miit.gov.cn">{{number}}</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      localhost: 'renderg.com',
      number: '京ICP备2020032443号-2'
    }
  },
  created () {
    this.year = new Date().getFullYear()
    // this.getRecordHost()
  },
  // methods: {
  //   getRecordHost () {
  //     let str = window.location.href.split('#')[0].split('/')[2]
  //     // console.log('str', str)
  //     this.recordData.forEach((item, index) => {
  //       // console.log('item', item)
  //       if (item.localhost.indexOf(str) != -1) {
  //         this.localhost = item.localhost.slice(4)
  //         this.number = item.number
  //       }
  //     })
  //   }
  // },
}
</script>